module.exports = __webpack_public_path__ + "static/media/razor-pay.649ed2f4.svg";